import axiosNew from "../../../helpers/axios"
import { buildQueryParams } from "../../../utils/commonUtils";

export const getAllTaskLogList = async (skip, limit, filter, search, workspaceId) => {
    return new Promise(async (resolve) => {
        const query = buildQueryParams(filter);

        let url = `users/get-user-list-with-logs?limit=1000&skip=0`;

        // Append workspaceId only if it exists
        if (workspaceId) {
            url += `&workspaceId=${workspaceId}`;
        }

        // Append query if it exists
        if (query) {
            url += `&${query}`;
        }

        // Append search if it exists
        if (search) {
            url += `&search=${encodeURIComponent(search)}`;
        }
        try {
            const res = await axiosNew({
                url,
                method: 'GET'
            })
            resolve({ data: res.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}

